import { Link as RouterLink, useLocation } from "react-router-dom";
import {
  Breadcrumbs as MUIBreadcrumbs,
  Typography,
  Link,
  Box,
} from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Index";

const hiddenSegments = ["view", "individual"];

const formatSegment = (segment: string) => {
  return segment
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const Breadcrumbs = () => {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.auth.user);

  const fullPathnames = location.pathname.split("/").filter((x) => x);

  const displaySegments = fullPathnames
    .map((seg, i) => ({ seg, index: i }))
    .filter(({ seg }) => !hiddenSegments.includes(seg));

  const isDashboard = location.pathname === "/dashboard";

  const lastSegment = isDashboard
    ? "Dashboard"
    : formatSegment(displaySegments[displaySegments.length - 1].seg);

  return (
    <Box sx={{ ml: 32, mt: 0 }}>
      {/* Main Title */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: "600",
          mb: isDashboard ? 0.5 : 1,
          color: "text.primary",
        }}
      >
        {isDashboard ? "Welcome" : lastSegment}
      </Typography>

      {/* Sub-title if on dashboard */}
      {isDashboard && user?.first_name && (
        <Typography variant="subtitle1" sx={{ color: "text.secondary" }}>
          {user.first_name} {user.last_name}
        </Typography>
      )}

      {/* Breadcrumbs (hidden if on dashboard) */}
      {!isDashboard && (
        <MUIBreadcrumbs aria-label="breadcrumb">
          {displaySegments.map(({ seg, index }, displayIndex) => {
            const to = `/${fullPathnames.slice(0, index + 1).join("/")}`;
            const isLast = displayIndex === displaySegments.length - 1;

            return isLast ? (
              <Typography
                key={to}
                color="text.primary"
                sx={{ fontSize: "1rem", fontWeight: 500 }}
              >
                {formatSegment(seg)}
              </Typography>
            ) : (
              <Link
                component={RouterLink}
                key={to}
                underline="hover"
                color="text.secondary"
                to={to}
                sx={{ fontSize: "1rem", fontWeight: 300 }}
              >
                {formatSegment(seg)}
              </Link>
            );
          })}
        </MUIBreadcrumbs>
      )}
    </Box>
  );
};

export default Breadcrumbs;
